export function getActionName(actionName) {
    return `${actionName}_SUCCESS`;
}